var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V1.18517C0.00112824 1.26585 0.033509 1.34281 0.0900899 1.39928L4.46246 5.90181C4.51904 5.95829 4.55142 6.03525 4.55255 6.11593V10.3309C4.55244 10.3883 4.56815 10.4445 4.59788 10.4931C4.62761 10.5418 4.67018 10.581 4.72072 10.6062L7.09309 11.4688C7.13892 11.4917 7.18972 11.5023 7.24068 11.4996C7.29165 11.4969 7.34111 11.4811 7.38438 11.4535C7.42766 11.426 7.46333 11.3876 7.48803 11.3421C7.51272 11.2966 7.52563 11.2455 7.52553 11.1935V6.06087C7.53383 5.97819 7.57244 5.90173 7.63363 5.84675L11.9099 1.41152C11.9665 1.35504 11.9989 1.27808 12 1.1974V0.5H0Z",
    fill: "#EDE5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.13d6de074d533e2ba7d950c78e8d5386.svg";
export { ForwardRef as ReactComponent };